import { useState,useEffect, useCallback,useMemo } from "react";
import {Table,Typography,message,Space} from "antd";
import UserService from "../../../services/UserService";
import CenterService from "../../../services/CenterService";
import { selectUser } from "../../../Auth/userReducer";
import { useHistory,useLocation } from "react-router-dom";
import {  useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {SolutionOutlined} from "@ant-design/icons"
import TransferUser from "../../Layouts/TransferUser/TransferUser";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import InstituteService from "../../../services/InstituteService";
const {Text}= Typography



export default function CenterListInvestigators(params) {
    const user = useSelector(selectUser);
    // const [messageApi, contextHolder] = message.useMessage();
    const [listUser,setListUser]=useState([])
    const [visibleModalTrasfer,setVisibleModalTrasfer]=useState(false)
    const [userTarget,setUserTarget]=useState({})
    const [listCentersOptions,setListCentersOptions]=useState([])
    const [listInstitutessOptions,setListInstitutesOptions]=useState([])
    const [institutesID,setInstitutesID]=useState()
    const history = useHistory();
    const { search } = useLocation();
    const searchParams = useMemo(
        () => new URLSearchParams(search),[search]
      );

    const {id:CenterID}=useParams()
    const [viewOptions,setViewOptions]=useState(false)
    const [needReloadUSer,setNeedReloadUSer]=useState(false)
    
    const setOpenModal=(state)=>{
      setVisibleModalTrasfer(state)
    }

    const setInstituteID=(InstID)=>{
      setInstitutesID(InstID)
    }

    const setViewOptionsByCenter=(opt)=>{
      setViewOptions(opt)
    }

    const setNeedReloadUSerOpt=(opt)=>{
      setNeedReloadUSer(opt)
    }

    const optionsModalTransferUser={
      openModal:visibleModalTrasfer,
      setOpenModal:setOpenModal,
      UserTarget:userTarget,
      ListCenters:listCentersOptions,
      ListInstitutes:listInstitutessOptions,
      setInstitute:setInstituteID,
      viewOptions:viewOptions,
      SetViewOptions:setViewOptionsByCenter,
      setNeedReloadUSer:setNeedReloadUSerOpt,
    }
    const getUsersByCenter=useCallback(()=> {
        UserService.getAllUsersByCenter(CenterID)
        .then((res)=>{
            const listUsers=res?.data?.response
            setListUser(listUsers)
        }).catch((error)=>{
          message.warning(error)
        })
    });
    const listCentersLikeOptions=(list,setlist)=>{
      let listRes=[]
      list.map(Center=>listRes.push({
        value: Center.id,
        label: Center.acronym,
      })) 
      setlist(listRes);
    }
    const getListCenter=useCallback((InstituteID,ViewOptions)=>{
      if(ViewOptions){
      CenterService.getListCentersByInstitute(InstituteID).then((res)=>{
        let listCenters=res?.data?.response;
        listCentersLikeOptions(listCenters,setListCentersOptions);
      })
      }else{
      CenterService.getAllCentersWithoutInstitute().then((res)=>{
          let listCenters=res?.data?.response;
          listCentersLikeOptions(listCenters,setListCentersOptions);
        })
      }

    },[]);

    const getListInstitutes=useCallback(()=>{
      InstituteService.getAllInstitutes().then((res)=>{
        let listInstitutes=res?.data?.response;
        listCentersLikeOptions(listInstitutes,setListInstitutesOptions);
      })
    });

    
    useEffect(()=>{
        getUsersByCenter()
        getListInstitutes()
        getListCenter(institutesID)
        setVisibleModalTrasfer(false);
        if (searchParams.get('option')!=="listInvestigators") {
          searchParams.set('option', 'listInvestigators');
          history.replace({ search: searchParams.toString() });
      }
    },[])


    useEffect(()=>{
      getListCenter(institutesID,viewOptions)
    },[institutesID,viewOptions])

    useEffect(()=>{
      getUsersByCenter()
      setNeedReloadUSer(false)
    },[needReloadUSer])

    

    // const EditableCell = ({
    //     editing,
    //     dataIndex,
    //     title,
    //     inputType,
    //     record,
    //     index,
    //     children,
    //     ...restProps
    //   }) => {
    //     const inputNode = inputType === 'select' ? 
    //     <Select options={listCenter} />
    //     :<Input/>;
    //     return (
    //       <td {...restProps}>
    //         {editing ? (
    //           <Form.Item
    //             name={dataIndex}
    //             style={{
    //               margin: 0,
    //             }}
    //             rules={[
    //               {
    //                 required: true,
    //                 message: `Por favor seleccione un ${title}!`,
    //               },
    //             ]}
    //           >
    //             {inputNode}
    //           </Form.Item>
    //         ) : (
    //           children
    //         )}
    //       </td>
    //     );
    //   };

      // const edit = (record) => {
      //   setEditingKey(record.id);
      // };

      // const cancel = () => {
      //   setEditingKey('');
      // };
      // const save = async (key) => {
      //   try {
      //     console.log("key",key)
      //     const row = await form.validateFields();
      //     const newData = [...listUser];
      //     const index = newData.findIndex((item) => key === item.id);
      //     if (index > -1) {
      //       const item = newData[index];
      //       /*newData.splice(index, 1, {
      //         ...item,
      //         ...row,
      //       });*/
      //       messageApi.loading({
      //         keyMessage,
      //         type: 'loading',
      //         content: 'Procesando...',
      //         duration: 1,
      //       });
      //       let centerID=row;
      //       if (item.centerId!==centerID.centerId) {
      //         CenterService.transferToUserAnotherCenter(item.id,centerID).then((res)=>{
      //           console.log("CambioDECenter",res)  
      //           messageApi.open({
      //             keyMessage,
      //             type: 'sucess',
      //             content: 'Cambio exitoso',
      //             duration: 2,
      //           })              
      //         });
      //         newData.splice(index,1)
      //         setListUser(newData);
      //         setEditingKey(''); 
      //       }else{
      //         newData.splice(index, 1, {
      //           ...item,
      //           ...row,
      //         });
      //         messageApi.open({
      //           key,
      //           type: 'sucess',
      //           content: 'Cambio exitoso',
      //           duration: 1,
      //         })    
      //       setListUser(newData);
      //       setEditingKey('');
      //       }
      //     } else {
      //       newData.push(row);
      //       setListUser(newData);
      //       setEditingKey('');
      //     }
      //   } catch (errInfo) {
      //     console.log('El campo seleccionado es invalido', errInfo);
      //   }
      // };

    const columns=[
        {
            title:'Nombre completo',
            dataIndex:'id',
            width: 100,
            key:'id',
            fixed: 'left',
            render:(i,record)=>{
                const rowName=record?.firstName+" "+record?.lastName;
                return <Text  style={ {
                    width: "100%" ,
                  }}
                  ellipsis={{tooltip: {rowName}}}>
                    {rowName}
                  </Text>

            }
        },
        {
            title:'Rol asignado',
            dataIndex:'systemRolId',
            key:'systemRolId',
            render:(i,record)=>{
                const rowSystemRol=record?.SystemRol?.name
                return <Text  style={ {
                    width: "100%" ,
                  }}
                  ellipsis={{tooltip: {rowSystemRol}}}>
                    {rowSystemRol}
                  </Text>
            }
        },
        {
            title:'Celular',
            dataIndex:'cellPhone',
            key:'cellPhone',
            render: (_, record) => {
              let phone=record.Contact?.cellPhone;
              return <Text  style={ {
                width: "100%" ,
              }}
              >
                {phone}
              </Text>

            }
        },
        {
            title:'Correo electronico',
            dataIndex:'email',
            key:'email',
        },
        {
          title:'Cantidad de projectos',
          dataIndex:'centerId',
          key: 'centerId',
          fixed: 'right',
          width: 50,
          render: (_, record) => {
            const rowName=record?.UserProjects?.length
                return <Text  style={ {
                    width: "100%" ,
                  }}
                  ellipsis={{tooltip: {rowName}}}>
                    {rowName}
                  </Text>
          }
        },  
        // {
        //     title: 'Transferencias de centro',
        //     dataIndex: 'operation',
        //     render: (_, record) => {
        //       const editable = isEditing(record);
        //       return editable ? (
        //         <span>
        //           <Typography.Link
        //             onClick={() => save(record.id)}
        //             style={{
        //               marginRight: 8,
        //             }}
        //           >
        //             Guardar
        //           </Typography.Link>
        //           <Popconfirm title="Esta seguro de cancelar?" onConfirm={cancel}>
        //             <a>Cancelar</a>
        //           </Popconfirm>
        //         </span>
        //       ) : (
        //         <Typography.Link disabled={editingKey !== ''} onClick={() => edit(record)}>
        //           Cambiar de centro
        //         </Typography.Link>
                
        //       );
        //     },
        //   },
    ]
    // const mergedColumns = columns.map((col) => {
    //     if (!col.editable) {
    //       return col;
    //     }
    //     return {
    //       ...col,
    //       onCell: (record) => ({
    //         record,
    //         inputType: col.dataIndex === 'centerId' ? 'select' : 'text',
    //         dataIndex: col.dataIndex,
    //         title: col.title,
    //         editing: isEditing(record),
    //       }),
    //     };
    //   });


    const OptionsTableByRol=()=>{
      let columnsOpt=columns
      if(user.rolName==="Coordinador del centro"){
        columnsOpt.push(
          {
          title:"Opciones sobre usuario",
          dataIndex:"",
          key: "optionsForm",
          fixed: 'right',
          width: 200,
          render:(_, record) => (
            <Space size="large" align='center'>
              <Link style={{display:"flex", flexDirection:"column"}} to={"/profile/"+record.id}>
              <SolutionOutlined />
              <Text> Información</Text>
              </Link >
                <Link style={{display:"flex", flexDirection:"column"}} onClick={()=>{
                  setVisibleModalTrasfer(true)
                  setUserTarget(record)
                  }}>
              <SolutionOutlined />
              <Text>Transferencia</Text>
              </Link>
            </Space>
          ),
        },
        )
      }
      return columnsOpt
    }
    return (
        <>
        {/* {contextHolder}    */}
            {/* <Table
            // components={{
            //     body: {
            //       cell: EditableCell,
            //     },
            //   }}
            columns={columns}
            rowKey="id"
            dataSource={listUser}
            rowClassName="editable-row"
            >
            </Table> */}

        <Table
        style={{
          width: "100%"
        }}
        columns={OptionsTableByRol( )}
        rowKey="id"
        dataSource={listUser}
        >

        </Table>
        <TransferUser
        {...optionsModalTransferUser}
        >

        </TransferUser>
        </>
    )
    
}